document.addEventListener("algolia.hooks.initialize", function () {
  const priceThreshold = 15000;
  // window.shopifyMarketCountry !== 'GB' && window.shopifyMarketCountry !== 'IE' && window.shopifyMarketCountry !== 'JE' if active
  if (
    false
  ) {
    // Disable Algolia autocomplete UI (remove hooks or hide original container)
    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteMainTemplate",
      () => ""
    );
    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteProductTemplate",
      () => ""
    );
    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteSuggestionsTemplate",
      () => ""
    );
    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteCollectionsTemplate",
      () => ""
    );

    const observer = new MutationObserver((mutations, obs) => {
      const input = document.getElementById("autocomplete-0-input");
      if (input) {
        console.log("Found input:", input);
        obs.disconnect();

        const form = input.closest("form");
        if (!form) {
          console.error("Form enclosing the input not found!");
          return;
        }

        let debounceTimeout;
        input.setAttribute("autocomplete", "off");

        function removeDropdown() {
          const old = document.querySelector(".custom-predictive-dropdown");
          if (old) old.remove();
        }

        function escapeHtml(text) {
          return text
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
        }

        function renderDropdown(query, data) {
          removeDropdown();
          if (!query) return;

          const container = document.createElement("div");
          container.className =
            "custom-predictive-dropdown predictive-container_wrapper";
          container.style.position = "absolute";
          container.style.background = "#000453";
          container.style.border = "1px solid #ccc";
          container.style.width = "100%";
          container.style.top = input.offsetTop + input.offsetHeight + "px";
          container.style.left = input.offsetLeft + "px";
          container.style.zIndex = "1000";
          // container.style.maxHeight = '300px';
          container.style.overflowY = "auto";
          container.style.display = "flex";
          container.style.flexDirection = "column";
          container.style.alignItems = "stretch";

          // Products column
          if (
            data.resources &&
            data.resources.results &&
            data.resources.results.products &&
            data.resources.results.products.length
          ) {
            const productsCol = document.createElement("div");
            productsCol.className =
              "predictive-container_inner-col predictive-container_inner-col--products --word-break";

            const title = document.createElement("strong");
            title.className =
              "predictive-container_title text-size--small --word-break";
            title.textContent = "Products";
            // productsCol.appendChild(title);

            const ul = document.createElement("ul");
            ul.className = "list-unstyled predictive-container_list";

            data.resources.results.products.forEach((product) => {
              const li = document.createElement("li");
              li.className = "predictive-container_list-item";

              const a = document.createElement("a");
              a.className = "predictive-container_list-link --word-break";
              a.href = product.url || `/products/${product.handle}`;

              const productTitle = product.title || "";
              const lowerTitle = productTitle.toLowerCase();
              const lowerQuery = query.toLowerCase();
              const idx = lowerTitle.indexOf(lowerQuery);

              if (idx >= 0) {
                a.innerHTML =
                  escapeHtml(productTitle.substring(0, idx)) +
                  `<mark>${escapeHtml(
                    productTitle.substring(idx, idx + query.length)
                  )}</mark>` +
                  escapeHtml(productTitle.substring(idx + query.length));
              } else {
                a.textContent = productTitle;
              }

              li.appendChild(a);
              ul.appendChild(li);
            });

            productsCol.appendChild(ul);
            container.appendChild(productsCol);
          }

          // Append search button BELOW products container
          const btnWrapper = document.createElement("div");
          btnWrapper.className = "predictive-container_btn-wrapper";
          btnWrapper.style.padding = "10px";
          btnWrapper.style.textAlign = "center";

          const btn = document.createElement("button");
          btn.type = "submit";
          btn.className = "button button--primary predictive-container_btn";
          btn.textContent = `SEARCH FOR “${query}”`;

          btnWrapper.appendChild(btn);
          container.appendChild(btnWrapper);

          const parent = input.parentNode;
          if (window.getComputedStyle(parent).position === "static") {
            parent.style.position = "relative";
          }
          parent.appendChild(container);

          btn.addEventListener("click", (e) => {
            e.preventDefault();
            const encodedQuery = encodeURIComponent(query);
            window.location.href = `/search?q=${encodedQuery}&options%5Bprefix%5D=last`;
          });
        }

        input.addEventListener("input", () => {
          clearTimeout(debounceTimeout);
          const query = input.value.trim();
          if (!query) {
            removeDropdown();
            return;
          }
          debounceTimeout = setTimeout(() => {
            fetch(
              `/search/suggest.json?q=${encodeURIComponent(
                query
              )}&resources[type]=product&resources[limit]=5`
            )
              .then((r) => r.json())
              .then((data) => renderDropdown(query, data))
              .catch(() => removeDropdown());
          }, 300);
        });

        document.addEventListener("click", (e) => {
          const dropdown = document.querySelector(
            ".custom-predictive-dropdown"
          );
          if (!dropdown) return;
          if (!input.contains(e.target) && !dropdown.contains(e.target)) {
            removeDropdown();
          }
        });
      } else {
        console.error("Input with ID autocomplete-0-input not found yet...");
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return; // stop further autocomplete processing for non-GB/IE
  }

  // Normal GB/IE hooks continue here (your existing priceThreshold logic)
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (hit) {
      setTimeout(() => {
        document
          .querySelectorAll(".aa-ItemContentPriceCurrent")
          .forEach((priceElement) => {
            const priceText = priceElement.textContent
              .trim()
              .replace(/[^\d.]/g, "");
            const price = parseFloat(priceText);
            if (price > priceThreshold) {
              priceElement.innerHTML =
                '<span style="visibility: hidden;">.</span>';
            }
          });
      }, 100);
      return hit;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchProductTemplate",
    function (hit) {
      setTimeout(() => {
        // Remove "Organ Charts" refinement item
        document.querySelectorAll('.ais-RefinementList-item').forEach(item => {
          const label = item.querySelector('.ais-RefinementList-label');
          if (label && label.textContent.trim().includes('Organ Charts')) {
            item.remove();
          }
        });
    
        // Remove "klaviyo_reviews_exclude" refinement item
        document.querySelectorAll('.ais-RefinementList-item').forEach(item => {
          const label = item.querySelector('.ais-RefinementList-label');
          if (label && label.textContent.trim().includes('klaviyo_reviews_exclude')) {
            item.remove();
          }
        });
        
        document
          .querySelectorAll(".ais-hit--price b")
          .forEach((priceElement) => {
            const priceText = priceElement.textContent
              .trim()
              .replace(/[^\d.]/g, "");
            const price = parseFloat(priceText);
            if (price > priceThreshold) {
              priceElement.innerHTML =
                '<span style="visibility: hidden;">.</span>';
            }
          });
      }, 100);
      return hit;
    }
  );
});

(function() {
  const urlsToRemove = [
    '/collections/digital-downloads',
    '/collections/veterinary-digital-downloads-pdfs',
    '/collections/womens-health-digital-products-resources',
    '/collections/medical-condition-posters',
    '/collections/revision-guide-one-page-summaries',
    '/collections/anatomical-charts-posters',
    '/collections/clinical-skills-training-charts-posters',
    '/collections/anatomy-revision-guides-summaries'
  ];

  function terminateCollections() {
    const list = document.getElementById('autocomplete-0-collections-list');
    if (!list) return;
    
    list.querySelectorAll('li.aa-Item').forEach(item => {
      const link = item.querySelector('a.aa-ItemLink');
      if (link && urlsToRemove.includes(link.getAttribute('href'))) {
        item.remove();
      }
    });
  }

  terminateCollections();

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(() => terminateCollections());
  });
  
  const targetList = document.getElementById('autocomplete-0-collections-list');
  if (targetList) {
    observer.observe(targetList, {
      childList: true,
      subtree: true
    });
  }

  setInterval(terminateCollections, 200);

  document.getElementById('autocomplete-0-input')?.addEventListener('input', terminateCollections);
})();